(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  function money(v) {
    return '€ ' + Number(v || 0).toFixed(2).replace('.', ',');
  }
  function initDrawerSearch() {
    document.querySelectorAll('[data-predictive-drawer]').forEach(function (wrap) {
      if (wrap.dataset.psInit) return;
      wrap.dataset.psInit = '1';
      var input = wrap.querySelector('.menu-drawer__search-input');
      var results = wrap.querySelector('[data-results]');
      var searchUrl = wrap.getAttribute('data-search-url') || '/search';
      /* Teksten komen uit data-attributen: Liquid wordt niet gerenderd in dit javascript-blok,
         en een Liquid-tag hier breekt de hele gebundelde snippet-scripts.js. */
      var viewAllText = wrap.getAttribute('data-view-all') || 'Bekijk alle resultaten';
      var emptyText = wrap.getAttribute('data-empty') || 'Geen producten gevonden.';
      if (!input || !results) return;
      var timer, controller;
      function render(products, q) {
        if (!products.length) {
          results.innerHTML = '<p class="menu-drawer__results-empty">' + emptyText + '</p>';
          results.hidden = false;
          return;
        }
        var html = products.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          if (img) img = img.split('?')[0] + '?width=160';
          var price = money(p.price_min);
          if (p.compare_at_price_min && p.compare_at_price_min > p.price_min) {
            price = '<s class="menu-drawer__result-was">' + money(p.compare_at_price_min) + '</s>' + price;
          }
          var imgEl = img
            ? '<img class="menu-drawer__result-img" src="' + img + '" alt="" width="48" height="48" loading="lazy">'
            : '<span class="menu-drawer__result-img"></span>';
          return '<a class="menu-drawer__result" href="' + p.url + '">' + imgEl +
            '<span class="menu-drawer__result-info">' +
            '<span class="menu-drawer__result-title">' + p.title + '</span>' +
            '<span class="menu-drawer__result-price">' + price + '</span>' +
            '</span></a>';
        }).join('');
        html += '<a class="menu-drawer__result-all" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '">' + viewAllText + '</a>';
        results.innerHTML = html;
        results.hidden = false;
      }
      function search(q) {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (((data.resources || {}).results || {}).products) || [];
            render(products, q);
          })
          .catch(function () {});
      }
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }
        timer = setTimeout(function () { search(q); }, 250);
      });
    });
  }
  if (document.readyState !== 'loading') initDrawerSearch();
  document.addEventListener('DOMContentLoaded', initDrawerSearch);
})();
  } catch(e) { console.error(e); }
})();

})();
